import { useDropzone, FileRejection, ErrorCode } from "react-dropzone";
import { NotifierFactory } from "@shared/services/api/abstracts/notifiers/NotifierFactory";
import { getExceptionToastDescription } from "@shared/utils/errors/error-utils";
import { GenericUploadInputPropsType } from "./GenericUploadInput.props";

export function useGenericUploadInput(props: GenericUploadInputPropsType) {
  const {
    onDrop,
    updateDocument,
    updateCurrentFile,
    maxFileSize,
    acceptedFileTypes,
    handleErrorCodes,
  } = props;

  const notifier = NotifierFactory.createNotifier();

  const customOnDrop = async (
    fileList: Array<File>,
    fileRejections: Array<FileRejection>
  ) => {
    // Handle file rejections (size, type, count errors) first
    if (fileRejections.length > 0) {
      updateDocument(undefined);
      updateCurrentFile(undefined);

      // only want to trigger 1 "too many alert" toasts
      // when user tries to upload many
      let tooManyFilesAlerts = false;

      fileRejections.forEach((rejection) => {
        rejection.errors.forEach((error) => {
          if (error.code === ErrorCode.TooManyFiles && tooManyFilesAlerts) {
            return;
          }
          if (error.code === ErrorCode.TooManyFiles) {
            tooManyFilesAlerts = true;
          }

          notifier.error(
            getExceptionToastDescription(handleErrorCodes[error.code])
          );
        });
      });
      return;
    }

    // Process accepted files
    try {
      onDrop(fileList);
    } catch (e) {
      updateDocument(undefined);
      updateCurrentFile(undefined);
    }
  };

  const removeDocument = () => {
    updateDocument(undefined);
    updateCurrentFile(undefined);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: customOnDrop,
    maxSize: maxFileSize,
    minSize: undefined,
    accept: acceptedFileTypes,
    maxFiles: 1,
    multiple: false,
  });

  return {
    getRootProps,
    getInputProps,
    isDragActive,
    removeDocument,
  };
}
